export enum WorkflowActionTarget {
  Printer = 1 << 0,
  Telegram = 1 << 1
}

export const WorkflowActionTargetLabels: { [key: string]: string } = {
  [WorkflowActionTarget.Printer]: 'Drucker',
  [WorkflowActionTarget.Telegram]: 'Telegram'
}
